import type { ApiError } from "../../api/client";

/**
 * ChannelDeleteButton shows its own inline message for these two answers, so the global
 * failed-write toast must stay quiet (otherwise a generic «بيانات غير صحيحة» toast duplicates it).
 */
export function isInlineChannelDeleteError(
  error: Pick<ApiError, "code">,
  request: { readonly method: string; readonly path: string },
): boolean {
  return (
    request.method === "DELETE" &&
    /\/channels\/[^/]+$/.test(request.path) &&
    (error.code === "CHANNEL_CONFIRMATION_MISMATCH" || error.code === "CHANNEL_NOT_DISCONNECTED")
  );
}
